import { Callout, Checkbox, DefaultButton, DirectionalHint, Icon, Label, SearchBox,Dropdown,Stack, mergeStyles} from "@fluentui/react";
import React, { useEffect, useRef, useState, useContext} from "react";
// import { mergeStyles } from "react-select";
import themeContext from "../context/theme/ThemeContext";


const CustomMultiSelectDropdown = ({
  options,
  label,
  placeholder,
  searchPlaceholder,
  styles,
  dropdownRef,
  selectedKeys,
  setSelectedKeys,
  customClassName,
  showSelectAll,
  calloutProps,
  multiSelect = true, 
  showCheckbox = true,
}) => {
  const containerRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { getThemeColor, themeName } = useContext(themeContext);
  const dismissMenuRef = useRef(null); 

  const getDropdownTarget = () => {
    const el = containerRef.current;
    if (!el || el.children.length === 0) return el;
    return el.children[el.children.length - 1];
  };

  const onSearchChange = (event, newValue) => {
    setSearchText(newValue || "");
  };

  const onCheckboxChange = (event, option) => {
    if (option.key === "__selectAll__") {
      if (!multiSelect) return; // if single select mode, do not allow select all
      if (option.selected) {
        setSelectedKeys(options.map(o => o.key));
      } else {
        setSelectedKeys([]);
      }
      return;
    }
      const newSelectedKeys = [...selectedKeys];
      if (option.selected) {
        if (multiSelect) {
          newSelectedKeys.push(option.key);
        } else {
          // Single‑select: replace the entire selection
          setSelectedKeys([option.key]);
          dismissMenuRef.current?.dismissMenu?.();
          setIsOpen(false);
          setSearchText("");
          return;
        }
      } else {
        const index = newSelectedKeys.indexOf(option.key);
        if (index > -1) {
          newSelectedKeys.splice(index, 1);
        }
      }
      setSelectedKeys(newSelectedKeys);
    };

  useEffect(() => {
    if (options.length > 0) {
      const tempFilteredOptions = options.filter((option) => {
        return option.text.toLowerCase().includes(searchText.toLowerCase())?? false;
      });
      setFilteredOptions(tempFilteredOptions);
    }
  }, [options, searchText]);

    useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchText("");
      }
    };

    if (isOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen]);

  const allSelected = options.length > 0 && selectedKeys?.length === options.length;

  const renderOption = (option) => {
  const isSelected = selectedKeys.includes(option.key);

  if (showCheckbox) {
    // unchanged — original checkbox rendering
    return (
      <div key={option.key} className={mergeStyles({ padding: "0px 8px" })}>
        <Checkbox
          label={option.text}
          checked={isSelected}
          onChange={(e, checked) =>
            onCheckboxChange(e, { ...option, selected: checked })
          }
        />
      </div>
    );
  }

  // no checkbox — the row itself is the click target
  return (
      <div
        key={option.key}
        role="option"
        aria-selected={isSelected}
        onClick={() => onCheckboxChange(undefined, { ...option, selected: !isSelected })}
        className={mergeStyles({
          padding: "6px 8px",
          cursor: "pointer",
          fontSize: "14px",
          lineHeight: "18px",
          color: getThemeColor("primary-color"),
          backgroundColor: isSelected
            ? getThemeColor("popup-hover")
            : getThemeColor("action-details-background"),
          selectors: {
            ":hover": {
              backgroundColor: getThemeColor("popup-hover"),
            },
          },
        })}
      >
        {option.text}
      </div>
    );
  };
const handleDropdownClick = () => {
  setIsOpen(!isOpen);
};
  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      {label && <Label className={customClassName}>{label}</Label>}
      <Dropdown
        placeholder={
          multiSelect
            ? (selectedKeys?.length === 0 ? placeholder : `Selected ${selectedKeys?.length} of ${options?.length}`)
            :  options.find(o => o.key === selectedKeys[0])?.text ?? placeholder
        }
        onClick={handleDropdownClick}
        selectedKey={null}
        styles={styles}
        onRenderTitle={() => console.log("hi title is getting rendered")}
        onRenderContainer={({ calloutProps: dropdownCalloutProps }) => (
          isOpen ? (
            <Callout
              {...dropdownCalloutProps}
              {...calloutProps}
              target={getDropdownTarget()}
              doNotLayer={calloutProps?.doNotLayer ?? true}
              directionalHint={calloutProps?.directionalHint ?? DirectionalHint.bottomAutoEdge}
              calloutWidth={getDropdownTarget()?.offsetWidth}
              onDismiss={() => { setIsOpen(false); setSearchText(""); }}
            >
            <div className="custom-multiselect" data-theme={themeName}>
              <SearchBox placeholder={searchPlaceholder || "Search options"} onChange={onSearchChange} />
              <div style={{ maxHeight: 150, overflowY: "auto" }}>
                {showSelectAll && filteredOptions.length > 0 && (
                        <div className={mergeStyles({ padding: "0px 8px" })}>
                          <Checkbox
                            label="All"
                            checked={allSelected}
                            onChange={(e, checked) =>
                              onCheckboxChange(e, { key: "__selectAll__", selected: checked })
                            }
                          />
                        </div>
                      )}
                {filteredOptions.length > 0 ? (
                  filteredOptions.map(renderOption)
                ) : (
                  <div className="custom-multiselect-empty">No records found</div>
                )}
              </div>
            </div>
          </Callout>
          ) : null
        )}
        onRenderCaretDown={() => <Icon iconName="ChevronDown" />}
        onDismiss={() => { setIsOpen(false); setSearchText(""); }}
        componentRef={(instance) => {
          dismissMenuRef.current = instance;
          if (typeof dropdownRef === "function") {
            dropdownRef(instance);
          } else if (dropdownRef) {
            dropdownRef.current = instance;
          }
        }}
        className={customClassName}
      />
  </div>
);
};

const CustomMultiSelect = ({
  dropdownRef,
  options,
  placeholder,
  searchPlaceholder,
  selectedKeys,
  setSelectedKeys,
  customClassName,
  label,
  showSelectAll,
  calloutProps,
  multiSelect = true,
  showCheckbox = true,
}) => {
  const dropdownStyles = {
    dropdown: {
      width: "100%",
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "200px",
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white",
    },
  };

  return (
    <Stack tokens={{ childrenGap: 20 }}>
      <CustomMultiSelectDropdown
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        label={label}
        options={options}
        styles={dropdownStyles}
        dropdownRef={dropdownRef}
        selectedKeys={selectedKeys}
        setSelectedKeys={setSelectedKeys}
        customClassName={customClassName}
        showSelectAll={showSelectAll}
        calloutProps={calloutProps}
        multiSelect={multiSelect}
        showCheckbox={showCheckbox} 
      />
    </Stack>
  );
};
export default CustomMultiSelect;